export default __webpack_public_path__ + "static/emp-icn8-493b99875c54f5f497f31cd8b11ff25b.png";